// i18n area 'common' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.el-GR.meta.json.
import type { enUS } from './common'

export const elGR: typeof enUS = {
  nav: {
    home: 'Αρχική',
    vms: 'Εικονικές μηχανές',
    templates: 'Πρότυπα',
    importVms: 'Εισαγωγή VM',
    containers: 'Κοντέινερ',
    containersApps: 'Εφαρμογές',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Εικόνες OCI',
    containersOciRegistries: 'Μητρώα OCI',
    containersCtTemplates: 'Πρότυπα CT',
    networkServices: 'Υπηρεσίες δικτύου',
    firewall: 'Τείχος προστασίας',
    checkpoints: 'Checkpoint',
    backup: 'Αντίγραφα ασφαλείας',
    monitoring: 'Παρακολούθηση',
    cluster: 'Συστοιχία',
    clusterSettings: 'Καθολικές ρυθμίσεις',
    clusterNodes: 'Κόμβοι',
    clusterDevices: 'Πόροι USB και PCIe',
    clusterFederation: 'Ομοσπονδία',
    network: 'Δίκτυο',
    overlayNetworks: 'Δίκτυα επικάλυψης',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Αποθήκευση',
    data: 'Δεδομένα',
    storages: 'Χώροι αποθήκευσης',
    hci: 'Υπερσύγκλιση',
    ceph: 'Ceph',
    system: 'Σύστημα',
    tasks: 'Εργασίες',
    events: 'Συμβάντα',
    audit: 'Έλεγχος',
    diagnostics: 'Διαγνωστικά',
    notifications: 'Ειδοποιήσεις',
    proximity: 'TVirt Proximity',
    users: 'Χρήστες και ομάδες',
    groups: 'Ομάδες',
    mfa: 'MFA',
    realms: 'Realm και SSO',
    rbac: 'Ρόλοι και δικαιώματα',
    credentials: 'Διαπιστευτήρια',
    scopes: 'Scope',
    tags: 'Ετικέτες',
    explorer: 'Εξερεύνηση',
    licensing: 'Άδεια χρήσης',
    information: 'Πληροφορίες'
  },
  mode: {
    light: 'Φωτεινό',
    dark: 'Σκούρο',
    system: 'Συστήματος',
    tooltip: 'Θέμα'
  },
  language: {
    tooltip: 'Γλώσσα'
  },
  langRegion: {
    europe: 'Ευρώπη',
    northAmerica: 'Βόρεια Αμερική',
    southAmerica: 'Νότια Αμερική',
    asia: 'Ασία'
  },
  notFound: {
    title: 'Η σελίδα δεν βρέθηκε',
    body: 'Αυτή η διεύθυνση δεν αντιστοιχεί σε καμία σελίδα του TVirt — μπορεί να μετακινήθηκε με κάποια ενημέρωση, ή ο σύνδεσμος είναι παλιός.',
    backHome: 'Επιστροφή στην Αρχική'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Όλη η συστοιχία',
    noChildren: 'Κανένα υπο-scope εδώ',
    recursive: 'Συμπερίληψη απογόνων',
    collapse: 'Σύμπτυξη του πίνακα scope',
    openPicker: 'Εξερεύνηση των scope',
    up: 'Ένα επίπεδο πάνω',
    countTooltip: '{direct} σε αυτό το scope · {total} με τους απογόνους'
  },
  search: {
    tooltip: 'Αναζήτηση (⌘K)',
    placeholder: 'Αναζήτηση VM, δικτύων, χώρων αποθήκευσης…',
    empty: 'Κανένα αποτέλεσμα',

    // Γύρος command palette (#221, επικύρωση 2026-08-06): επικεφαλίδες των
    // ομάδων, οι τύποι εκτός της απογραφής του explorer, το λεξιλόγιο των
    // πλήκτρων και τα ρήματα της ομάδας «Ενέργειες».
    groups: {
      recent: 'Πρόσφατα',
      shortcuts: 'Συντομεύσεις',
      actions: 'Ενέργειες',
      goTo: 'Μετάβαση σε'
    },
    kind: {
      catalog: 'Κατάλογος',
      scope: 'Scope',
      node: 'Κόμβος'
    },
    footer: {
      navigate: 'πλοήγηση',
      open: 'άνοιγμα',
      close: 'κλείσιμο'
    },
    actions: {
      createVm: 'Δημιουργία VM…',
      uploadIso: 'Μεταφόρτωση ISO…',
      clusterSettings: 'Ρυθμίσεις συστοιχίας',
      consoleOf: 'Μετάβαση στην κονσόλα του {name}'
    }
  },
  stub: {
    containersSummary: 'Εφαρμογές και κοντέινερ συστήματος (CT), με τις εικόνες OCI, τα μητρώα και τα πρότυπά τους — η διαχείρισή τους γίνεται δίπλα στις VM σας.',
    sectionSummary_vms: 'Εικονικές μηχανές και τα πρότυπά τους — κύκλος ζωής, στιγμιότυπα, μετεγκατάσταση και κονσόλες.',
    sectionSummary_storages: 'Οι χώροι αποθήκευσης όπου ζουν οι δίσκοι, οι εικόνες και τα μεταδεδομένα των VM.',
    sectionSummary_catalogs: 'Το σπίτι των τεχνουργημάτων αρχείων της συστοιχίας: εικόνες ISO, πρότυπα CT και VM και αρχειοθήκες OCI, οργανωμένα σε καταλόγους.',
    sectionSummary_overlay: 'Δίκτυα επικάλυψης VXLAN μεταξύ των κόμβων της συστοιχίας.',
    sectionSummary_fabric: 'Η απογραφή του φυσικού δικτύου — μεταγωγείς, θύρες, LAGG και λογικά δίκτυα.',
    sectionSummary_ipam: 'Η διευθυνσιοδότηση που προκύπτει από τα δίκτυα fabric και επικάλυψης: ποιος κατέχει κάθε διεύθυνση.',
    sectionSummary_services: 'Διακομιστές DHCP και DNS που παράγονται από το μητρώο δικτύου.',
    sectionSummary_ceph: 'Διαχειριζόμενες συστοιχίες Ceph στους κόμβους TVirt.',
    sectionSummary_hci: 'Οι υπερσυγκλίνουσες τεχνολογίες αποθήκευσης στους κόμβους TVirt.',
    sectionSummary_cluster: 'Κόμβοι, ιδιότητα μέλους και ρυθμίσεις συστοιχίας.',
    containers: 'Τα κοντέινερ συστήματος είναι στον οδικό χάρτη — εδώ θα εμφανιστούν.',
    containersApps: 'Οι εφαρμογές σε κοντέινερ είναι στον οδικό χάρτη — εδώ θα εμφανιστούν.',
    containersPods: 'Τα pods ομαδοποιούν κοντέινερ που μοιράζονται δίκτυο και τόμους — τα στιγμιότυπα είναι οι εφαρμογές.',
    containersCt: 'Τα κοντέινερ συστήματος (CT) είναι στον οδικό χάρτη — εδώ θα εμφανιστούν.',
    multiscsi: 'Το TVStor MultiSCSI είναι στον οδικό χάρτη — εδώ θα εμφανιστεί.',
    clusterFederation: 'Η ομοσπονδία μεταξύ συστοιχιών TVirt είναι στον οδικό χάρτη — εδώ θα εμφανιστεί.',
    containersOciImages: 'Οι εικόνες OCI είναι στον οδικό χάρτη — εδώ θα εμφανιστούν.',
    containersOciRegistries: 'Τα μητρώα OCI είναι στον οδικό χάρτη — εδώ θα εμφανιστούν.',
    containersCtTemplates: 'Τα πρότυπα CT είναι στον οδικό χάρτη — εδώ θα εμφανιστούν.',
    importVms: 'Οι importer ESXi και Proxmox θα φτάσουν εδώ: μετατροπή των guest και μαζική μετεγκατάσταση μέσα στο TVirt.',
    backup: 'Το ενσωματωμένο αντίγραφο ασφαλείας φτάνει με την 6.2: αποθετήρια content-addressed με αποδιπλασιασμό, αυξητικά CBT, παράθυρα αμεταβλητότητας και αναπαραγωγή repo-to-repo.',
    monitoring: 'Οι πίνακες ελέγχου ανταγωνισμού πόρων σε επίπεδο συστοιχίας (cpu.ready, πίεση PSI, ενσωματωμένες ειδοποιήσεις) έρχονται — σήμερα οι ίδιες μετρικές ζουν στις λεπτομέρειες κάθε VM.'
  },
  home: {
    welcome: 'Έχετε συνδεθεί με τον λογαριασμό: {name}',
    subtitle: 'Ορίστε η συστοιχία TVirt σας με μια ματιά.',
    loadError: 'Δεν ήταν δυνατή η φόρτωση της επισκόπησης — είναι προσβάσιμο το backend του TVirt;',
    health: {
      ok: 'Όλα καλά',
      warning: 'Προσοχή',
      critical: 'Κρίσιμα προβλήματα'
    },
    reason: {
      'node-down': '{subject} είναι απενεργοποιημένος',
      'node-stale': '{subject} δεν έχει δώσει σημεία ζωής εδώ και λίγη ώρα',
      'node-maintenance': '{subject} σε συντήρηση',
      'tasks-failed': {
        one: '{n} αποτυχημένη εργασία τις τελευταίες 24 ώρες',
        other: '{n} αποτυχημένες εργασίες τις τελευταίες 24 ώρες'
      },
      'storage-degraded': 'ο χώρος αποθήκευσης {subject} είναι υποβαθμισμένος',
      'storage-error': 'ο χώρος αποθήκευσης {subject} σε σφάλμα',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'η αποθήκη της συστοιχίας δεν είναι προσβάσιμη',
      'license-absent': 'καμία άδεια χρήσης — οι νέες VM δεν μπορούν να εκκινήσουν',
      'license-expired': 'η άδεια χρήσης έληξε — οι νέες VM δεν μπορούν να εκκινήσουν',
      'license-exceeded': 'το όριο της άδειας χρήσης ξεπεράστηκε — οι νέες VM δεν μπορούν να εκκινήσουν',
      'failover-reserve-eroded': 'η εφεδρεία failover είναι σχεδόν εξαντλημένη',
      'failover-reserve-exhausted': 'η εφεδρεία failover εξαντλήθηκε — οι νέες VM δεν μπορούν να εκκινήσουν',

      'oci-cache-nearly-full': 'η cache OCI είναι σχεδόν γεμάτη στον {subject} — τα digest εκτοπίζονται χειροκίνητα',
      'oci-cache-full': 'η cache OCI είναι γεμάτη στον {subject} — κανένα pull δεν θα επιτύχει μέχρι να εκτοπίσετε digest',
      'config-replica-empty': 'το αντίγραφο διαμόρφωσης στον {subject} είναι ΑΔΕΙΟ — ο κόμβος δεν έχει διαμόρφωση συμπλέγματος μέχρι να πετύχει μια αναπαραγωγή',
      'config-replica-stalled': 'η αναπαραγωγή διαμόρφωσης στον {subject} έχει κολλήσει — το τοπικό αντίγραφο μένει πίσω από τη διαμόρφωση του συμπλέγματος'
    },
    staleChip: 'Μη ενημερωμένα δεδομένα',
    staleAsOf: 'τελευταίο αντίγραφο {time}',
    zone: {
      nodes: 'Κόμβοι',
      failoverReserve: 'Εφεδρεία failover',
      capacity: 'Χωρητικότητα',
      workload: 'Φορτίο εργασίας',
      protection: 'Προστασία',
      activity: 'Πρόσφατη δραστηριότητα'
    },

    // Η ζώνη «εφεδρεία failover» (έλεγχος εισδοχής N+1, εργασία #133b).
    reserve: {
      state: {
        ok: 'Εφεδρεία ανέπαφη',
        eroded: 'Εφεδρεία σχεδόν εξαντλημένη',
        exhausted: 'Εφεδρεία εξαντλημένη',
        unknown: 'Εφεδρεία άγνωστη'
      },
      tolerate: {
        one: 'ανέχεται την απώλεια {n} κόμβου',
        other: 'ανέχεται την απώλεια {n} κόμβων'
      },
      usedOf: '{used} / {allowed} GiB σε χρήση',
      keepFree: '{n} GiB διατηρούνται ελεύθερα για το failover',
      expendable: 'εκ των οποίων {n} αναλώσιμα εν λειτουργία',
      headroom: 'μπορούν ακόμη να εκκινηθούν {n} GiB',
      short: 'από την εφεδρεία λείπουν {n} GiB — οι νέες VM δεν μπορούν να εκκινήσουν',

      // Τεράστιες σελίδες ανά μέγεθος (επικύρωση 2026-08-04) — η μορφή
      // «επιγραφή: {n}» επίτηδες: καμία γλώσσα δεν χρειάζεται να κλίνει μετά
      // από μεταβλητό αριθμό.
      hp: {
        usedOf: 'Σελίδες των {size} — σε χρήση: {used} / {allowed}',
        keepFree: 'διατηρούνται ελεύθερες για το failover: {keep}',
        headroom: 'ακόμη εκκινήσιμες: {n}',
        short: 'λείπουν από την εφεδρεία: {n} — οι νέες VM με τεράστιες σελίδες δεν μπορούν να εκκινήσουν'
      },
      worstCase: 'χειρότερη περίπτωση: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Κανένας κόμβος δεν έχει δηλώσει ακόμη τη μνήμη του — η εφεδρεία δεν μπορεί να υπολογιστεί και καμία εκκίνηση δεν απορρίπτεται.',
      reason: {
        attestedDown: 'βεβαιωμένα απενεργοποιημένος',
        maintenance: 'σε συντήρηση',
        unreachable: 'μη προσβάσιμος',
        capacityUnknown: 'μη δηλωμένη μνήμη'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} πυρήνες / {threads} νήματα',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} ενεργή VM',
        other: '{n} ενεργές VM'
      },
      activeVmsUnknown: 'άγνωστες ενεργές VM',
      lastSeen: 'εθεάθη {time}',
      neverSeen: 'δεν εθεάθη ποτέ',
      down: 'Απενεργοποιημένος',
      maintenance: 'Συντήρηση',
      stale: 'Μη προσβάσιμος'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB σε provisioning',
      reserve: 'εφεδρεία {n} GiB',
      unobserved: 'η χωρητικότητα δεν έχει παρατηρηθεί ακόμη',
      empty: 'Κανένας χώρος αποθήκευσης ακόμη'
    },
    workload: {
      vms: 'Εικονικές μηχανές',
      apps: 'Εφαρμογές',
      services: 'Υπηρεσίες δικτύου',
      empty: 'Τίποτα ακόμη',
      phasesUnknown: 'η κατανομή ανά φάση δεν είναι διαθέσιμη'
    },
    protection: {
      none: 'Κανένας προορισμός backup δεν έχει διαμορφωθεί — προστατέψτε τη διαμόρφωσή σας.',
      configure: 'Διαμόρφωση checkpoint',
      noRuns: 'Κανένα checkpoint δεν έχει δημιουργηθεί ακόμη.',
      last: 'Τελευταίο checkpoint',
      onTarget: 'σε {target}',
      viewAll: 'Checkpoint'
    },
    activity: {
      empty: 'Καμία πρόσφατη δραστηριότητα',
      failed24: {
        one: '{n} απέτυχε σε 24 ώρες',
        other: '{n} απέτυχαν σε 24 ώρες'
      },
      viewAll: 'Προβολή όλων των εργασιών'
    }
  },
  notes: {
    title: 'Σημειώσεις',
    tabEdit: 'Επεξεργασία',
    tabPreview: 'Προεπισκόπηση',
    placeholder: 'Ελεύθερες σημειώσεις του χειριστή — το Markdown αποδίδεται στην προεπισκόπηση',
    empty: 'Καμία σημείωση',
    tooLarge: 'Οι σημειώσεις υπερβαίνουν το όριο των 64 KiB',
    saveError: 'Η αποθήκευση των σημειώσεων απέτυχε'
  },
  common: {

    // Γύρος «τίμια σφάλματα» (2026-08-03): μια απόκριση 200 που αυτός ο client
    // δεν ξέρει να διαβάσει ΔΕΝ είναι πεσμένο δίκτυο — το να κατηγορείς το
    // backend στέλνει τον χειριστή να κοιτάζει μια υπηρεσία που δουλεύει
    // (bug hunt #157, U1).
    contractError: 'Η απόκριση του backend περιέχει μια τιμή που αυτή η διεπαφή δεν γνωρίζει: {field}={value} — ενημερώστε τη διεπαφή web στην έκδοση του backend.',
    contractErrorItems: '{count} αντικείμενα αυτής της λίστας δεν είναι αναγνώσιμα από αυτήν τη διεπαφή ({field}={value}) και δεν εμφανίζονται.',
    staleHint: 'Η αποθήκη δεν είναι προσβάσιμη — αυτό είναι το αντίγραφο διαμόρφωσης αυτού του κόμβου· η κατάσταση του στόλου είναι άγνωστη.',
    staleStateAge: 'κατάσταση από {time}',
    staleStateNever: 'η κατάσταση δεν ελήφθη ποτέ από την αποθήκη: βλέπετε μόνο τις παρατηρήσεις αυτού του κόμβου',
    staleStateTooltip: 'Η αποθήκη του cluster δεν είναι προσβάσιμη: η παρατηρούμενη κατάσταση (φάση, κόμβος, agent) προέρχεται από το αντίγραφο κατάστασης αυτού του κόμβου και χρονολογείται από την τελευταία επιτυχή ανάγνωση από την αποθήκη — μπορεί να είναι παρωχημένη.',
    noPermission: 'Δεν έχετε δικαίωμα για αυτήν την ενέργεια',

    // Ένας εξαντλημένος προϋπολογισμός αναμονής ΔΕΝ είναι έκβαση (Luca
    // 2026-08-06): το χρονόμετρο του client μετρά την υπομονή του client, όχι
    // την κατάσταση του διακομιστή — η ειδοποίηση λέει «ακόμη σε εξέλιξη»,
    // ποτέ «απέτυχε».
    actionStillRunning: 'Η ενέργεια είναι ακόμη σε εξέλιξη: το αποτέλεσμα δεν είναι ακόμη γνωστό',
    staleWrite: 'Κάποιος άλλος άλλαξε αυτό το αντικείμενο ενώ το επεξεργαζόσασταν — δεν γράφτηκε τίποτα. Φορτώστε ξανά και επαναλάβετε την αλλαγή στην τρέχουσα κατάσταση.',
    staleReload: 'Επαναφόρτωση',
    preview: 'Προεπισκόπηση',
    previewTitle: 'Προεπισκόπηση του αποτελέσματος',
    previewNothingWritten: 'Προσομοιώθηκε στον διακομιστή — δεν γράφτηκε τίποτα.',
    previewChanged: 'Επισημαίνονται οι τιμές που θα άλλαζαν.'
  },
  context: {
    copySelection: 'Αντιγραφή επιλεγμένου κειμένου'
  },
  crud: {
    create: 'Δημιουργία',
    viewDetails: 'Προβολή λεπτομερειών',
    viewOrEdit: 'Προβολή ή επεξεργασία',
    selected: 'επιλεγμένα',
    viewUsingVms: 'Προβολή των VM που χρησιμοποιούν τον πόρο',
    clearSelection: 'Αναίρεση επιλογής',
    deleteSelected: 'Διαγραφή επιλεγμένων',
    bulkConfirmBody: {
      one: 'Να διαγραφεί {count} επιλεγμένο στοιχείο; Αν είναι προστατευμένο, θα αναφερθεί και θα διατηρηθεί.',
      other: 'Να διαγραφούν τα {count} επιλεγμένα στοιχεία; Τα προστατευμένα θα αναφερθούν και θα διατηρηθούν.'
    },
    bulkDeleted: 'διαγράφηκαν',
    bulkRefused: 'απορρίφθηκαν',
    fieldId: 'ID',
    createdAt: 'Δημιουργήθηκε στις',
    updatedAt: 'Ενημερώθηκε στις',
    immutableField: 'Ορίζεται κατά τη δημιουργία — το contract δεν επιτρέπει την αλλαγή του',
    immutableScope: 'Το scope εκχωρείται κατά τη δημιουργία· ορισμένοι πόροι μετακινούνται με ειδική ενέργεια',
    observedField: 'Παρατηρούμενη κατάσταση — αναφέρεται από την πλατφόρμα, μη επεξεργάσιμη'
  }
}
